/**
 * Normalizes a URL by ensuring it has a proper protocol
 * @param url - The URL to normalize
 * @returns The normalized URL with https:// protocol
 */
export function normalizeUrl(url: string): string {
  if (!url || typeof url !== 'string') {
    return url;
  }

  // Trim whitespace
  url = url.trim();

  // If it already has a protocol, return as is
  if (url.match(/^https?:\/\//)) {
    return url;
  }

  // If it starts with www. or is a domain, prepend https://
  if (url.match(/^(www\.|\w+\.)/)) {
    return `https://${url}`;
  }

  // For any other format, prepend https://
  return `https://${url}`;
}

/**
 * Validates if a string looks like a valid URL (with or without protocol)
 * @param url - The URL to validate
 * @returns true if it looks like a valid URL
 */
export function isValidUrlFormat(url: string): boolean {
  if (!url || typeof url !== 'string') {
    return false;
  }

  const trimmed = url.trim();
  
  // Check for various URL formats
  const patterns = [
    /^https?:\/\/.+/,           // http:// or https://
    /^www\..+/,                 // www.domain.com
    /^\w+\..+/,                 // domain.com
    /^file:.+/                  // file:filename.ext
  ];

  return patterns.some(pattern => pattern.test(trimmed));
}
